import { JSX } from 'react';
import { type RichTextField } from '@prismicio/client';
import { PrismicRichText, JSXMapSerializer } from '@prismicio/react';

// Components
import { RichTextDefaultConfiguration } from './Configuration';

type RichTextDefaultProps = {
  content: RichTextField;
};

const components: JSXMapSerializer = {
  ...RichTextDefaultConfiguration,
  list: ({ children }) => <ul className="ul-default flow">{children}</ul>,
  oList: ({ children }) => <ol className="ol-default flow">{children}</ol>,
};

export const RichTextDefault = ({
  content,
}: RichTextDefaultProps): JSX.Element => (
  <PrismicRichText field={content} components={components} />
);
